// @dynamic
/**
 * @dynamic need this because there are static memebers
 *
 * Email constants
 */

export class ZipcodeValidationMessagesConstants {

    /**
     * Constant for email pattern
     */
    public static readonly PATTERN: string = 'Please enter a valid zipcode';
  
    /**
     * Constant for email required
     */
    public static readonly REQUIRED: string = 'Email is required';
  
  }
  